<template>
  <VWidget title="Customer Note">
    <div slot="widget-content">
      <v-layout
        wrap
        row
      >
        <v-flex xs12>
          <v-flex class="blockquote">
            {{ note }}
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>
export default {
  name: 'OrderSingleNote',

  props: {
    note: {
      type: String,
      required: true
    }
  }
}
</script>
